/*프로젝트 아이템 dom으로 변환하여 반환하는 함수*/
export const getProjectsHtmByRecord = (prjArray) => {
    return prjArray.map((item) => {
        return getProjectItem(item);
    }).join('');
}

/* 프로젝트 아이템 단건으로 li 반환*/
const getProjectItem = (item) => {
    let {
        TTL,
        BG_COLOR_CD,
        BADGE_CNT,
        HOME_TAB_CODE,
        COLABO_SRNO
    } = item

    const title = TagUtil.escapeHtml(Often.null2Void(TTL, ""));
    return ` <li class="js-prj-item project-item" home-tab="${HOME_TAB_CODE}" project-srno="${COLABO_SRNO}">
                <span class="prj-icon-box color-code-${BG_COLOR_CD}">
                    <span class="num" style="display: ${+BADGE_CNT > 0 ? '' : 'none'}">${BADGE_CNT}</span>
                </span>
                <span class="prj-title js-mouseover js-over-tooltip" mouseover-text="${title}">${title}</span>
            </li>`
}
